'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _revalidate = require('revalidate');

var validate = (0, _revalidate.combineValidators)({
  comments: (0, _revalidate.composeValidators)((0, _revalidate.isRequired)({ message: 'Comments are required.' }), (0, _revalidate.hasLengthGreaterThan)(2))('Comments')
});

exports.default = validate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/reportAssetFormValidation.js
// module id = 2788
// module chunks = 0